import { render, staticRenderFns } from "./classical-remid-validation.vue?vue&type=template&id=b0c8e334"
import script from "./classical-remid-validation.vue?vue&type=script&lang=js"
export * from "./classical-remid-validation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports